import { apiClient } from "./client";
import type { PostEventsResponse, AnalyticsEvent } from "~/types/analytics";

/**
 * Send analytics events to backend via pubsub_algo API
 *
 * @param events - Array of analytics events to send
 * @returns Promise that resolves when events are sent
 */
export async function postAnalyticsEvents(events: AnalyticsEvent[]): Promise<PostEventsResponse> {
  const response = await apiClient.makeAuthenticatedRequest<PostEventsResponse>("/pubsub_algo/events", {
    method: "POST",
    params: { events },
  });
  return response;
}

/**
 * Send a single analytics event
 *
 * @param event - Single analytics event to send
 * @returns Promise that resolves when event is sent
 */
export async function postAnalyticsEvent(event: AnalyticsEvent): Promise<PostEventsResponse> {
  return postAnalyticsEvents([event]);
}
